var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Hello world "),_c('OButton',{on:{"click":_vm.greet}},[_vm._v("Greet")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }